import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import aboutImage from '../../assets/images/about.jpg';
import about1Image from '../../assets/images/about-1.png';
import './About.css';

const HeroSection = styled.section`
  position: relative;
  height: 60vh;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${aboutImage}) center center/cover no-repeat;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(37, 37, 37, 0.7);
    z-index: 1;
  }

  @media (max-width: 768px) {
    height: 30vh;
    min-height: 250px;
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  color: white;
`;

const HeroTitle = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 700;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin: 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 3rem;
  }

  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`;

const AboutSection = styled.section`
  padding: 6rem 0;
  background: white;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;



const CompanySection = styled.section`
  padding: 6rem 0;
  background: white;
`;

const CompanyContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const CompanyGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const CompanyImageContainer = styled.div`
  position: relative;
  height: 500px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    height: 300px;
  }
`;

const CompanyImage = styled.div`
  width: 100%;
  height: 100%;
  background: url(${about1Image}) center center/cover no-repeat;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(165, 95, 96, 0.3);
    z-index: 1;
  }
`;

const ImageOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  z-index: 2;
`;

const ImageTitle = styled.h3`
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
`;

const CompanyContent = styled.div`
  padding: 2rem 0;
  margin-top: 2rem;
`;

const CompanyTitle = styled(motion.h2)`
  font-size: 3rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 50px;
    height: 3px;
    background: #C31321;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const CompanyDescription = styled(motion.p)`
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.7;
  margin-top: 2rem;
  margin-bottom: 0;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-top: 1.5rem;
  }
`;

const About = () => {

  return (
    <>
      <HeroSection>
        <HeroContent>
          <HeroTitle
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            About Us
          </HeroTitle>
        </HeroContent>
      </HeroSection>

      

       <CompanySection>
         <CompanyContainer>
           <CompanyGrid>
             <CompanyImageContainer
               as={motion.div}
               initial={{ opacity: 0, x: -50 }}
               whileInView={{ opacity: 1, x: 0 }}
               viewport={{ once: true }}
               transition={{ duration: 0.8 }}
             >
                               <CompanyImage>
                </CompanyImage>
             </CompanyImageContainer>
             
             <CompanyContent>
                               <CompanyTitle
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8 }}
                >
                  KeyPlot<br />Investments
                </CompanyTitle>
               
               <CompanyDescription
                 initial={{ opacity: 0, x: 50 }}
                 whileInView={{ opacity: 1, x: 0 }}
                 viewport={{ once: true }}
                 transition={{ duration: 0.8, delay: 0.2 }}
               >
                 KeyPlot Investments (Pty) Ltd is a proudly Namibian property and parking management company with over 10 years' experience. We aspire to create a smart city eco-system in the area of mobility, public transportation and digital payments and in turn providing our customers with a seamless service.
               </CompanyDescription>
             </CompanyContent>
           </CompanyGrid>
         </CompanyContainer>
       </CompanySection>
     </>
   );
};

export default About; 